<template>
  <div :class="[{ 'rounded-sm border': hasBorder }, { expanded: isOpen }]">
    <div
      class="toggle-section__header flex cursor-pointer items-center px-4 pt-5"
      :class="{ 'border-b': isOpen && $slots.content && hasHeaderBottomBorder }"
      @click.stop="toggleOpen"
    >
      <span v-if="chevronPosition === 'left'" class="chevron pb-5">
        <icon-button>
          <dropdown-chevron
            :is-open="isOpen"
            :is-default-position="false"
            class="icon-base absolute inset-1/2 -translate-x-1/2 -translate-y-1/2 transform text-grey-icon"
          />
        </icon-button>
      </span>
      <div
        class="toggle-section__title flex w-full justify-between pb-5"
        :class="headerClass"
      >
        <slot name="titleSection" />
        <slot name="advanced" />
        <span v-if="chevronPosition === 'right'" class="chevron mb-0 h-10">
          <icon-button>
            <dropdown-chevron
              :is-open="isOpen"
              :is-default-position="false"
              class="icon-base absolute inset-1/2 -translate-x-1/2 -translate-y-1/2 transform text-grey-icon"
            />
          </icon-button>
        </span>
      </div>
    </div>
    <template v-if="persistSlotContent && $slots.content">
      <div
        v-show="isOpen"
        :class="{ 'p-5': hasPadding, 'bg-ghost-white': contentGray }"
      >
        <slot name="content" />
      </div>
    </template>
    <div
      v-if="!persistSlotContent && isOpen && $slots.content"
      :class="{ 'p-5': hasPadding, 'bg-ghost-white': contentGray }"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script setup lang="ts">
import IconButton from "@/components/ui/buttons/IconButton.vue";

interface Props {
  isOpen?: boolean;
  section: string;
  hasPadding?: boolean;
  hasBorder?: boolean;
  chevronPosition?: "left" | "right" | "";
  hasHeaderBottomBorder?: boolean;
  contentGray?: boolean;
  headerClass?: string;
  persistSlotContent?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  hasPadding: true,
  hasBorder: true,
  chevronPosition: "left",
  headerClass: "items-center",
});
const emit = defineEmits<{
  (eventName: "toggle", key: string): void;
}>();
const toggleOpen = () => {
  emit("toggle", props.section);
};
</script>
